// import { ENV_CONFIG } from 'shared/constants/environment';
// export const AUTH_ENABLED =
//   process.env.REACT_APP_AUTH_ENABLED &&
//   process.env.REACT_APP_AUTH_ENABLED.toLowerCase() === 'true';
// export const LOGIN_URL =
//   process.env.REACT_APP_LOGIN_URL || ENV_CONFIG.LOGIN_URL;
export const AUTH_TOKEN_KEY = 'auth_token';
export const CHECK_AUTH_TOKEN_TIMING = 5000;
//# sourceMappingURL=index.js.map